/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './ward-charges.reducer';

export const WardChargesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const wardChargesEntity = useAppSelector(state => state.wardCharges.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="wardChargesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.wardCharges.detail.title">WardCharges</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.wardCharges.id">Id</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.wardCharges.name">Name</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.wardCharges.description">Description</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.description}</dd>
          <dt>
            <span id="relatedTo">
              <Translate contentKey="tinyMedicRestApp.wardCharges.relatedTo">Related To</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.relatedTo}</dd>
          <dt>
            <span id="charge">
              <Translate contentKey="tinyMedicRestApp.wardCharges.charge">Charge</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.charge}</dd>
          <dt>
            <span id="chargeType">
              <Translate contentKey="tinyMedicRestApp.wardCharges.chargeType">Charge Type</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.chargeType}</dd>
          <dt>
            <span id="inwardChargeType">
              <Translate contentKey="tinyMedicRestApp.wardCharges.inwardChargeType">Inward Charge Type</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.inwardChargeType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.wardCharges.active">Active</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.wardCharges.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.wardCharges.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.wardCharges.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.wardCharges.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.cursor}</dd>
          <dt>
            <span id="tax">
              <Translate contentKey="tinyMedicRestApp.wardCharges.tax">Tax</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.tax}</dd>
          <dt>
            <span id="multiplierApplied">
              <Translate contentKey="tinyMedicRestApp.wardCharges.multiplierApplied">Multiplier Applied</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.multiplierApplied ? 'true' : 'false'}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.wardCharges.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.wardCharges.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.wardCharges.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.wardCharges.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{wardChargesEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.wardCharges.hospital">Hospital</Translate>
          </dt>
          <dd>{wardChargesEntity.hospital ? wardChargesEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.wardCharges.scheme">Scheme</Translate>
          </dt>
          <dd>{wardChargesEntity.scheme ? wardChargesEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.wardCharges.bed">Bed</Translate>
          </dt>
          <dd>{wardChargesEntity.bed ? wardChargesEntity.bed.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.wardCharges.room">Room</Translate>
          </dt>
          <dd>{wardChargesEntity.room ? wardChargesEntity.room.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/ward-charges" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/ward-charges/${wardChargesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WardChargesDetail;
